import * as React from 'react';
import ComponentStatusPicker, { Props } from './component_status_picker_adg3';

export default function(props: Props) {
  return <ComponentStatusPicker {...props} />;
}
